import type { FaireProductEntity } from "../../entity_types/product";

export const p_r2t6rskrt8: FaireProductEntity = {
  token: "p_r2t6rskrt8",
  type: "product",
  name: "18K STAINLESS STEEL TARNISH FREE CHAIN BRACELET | 40B5227",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/d18db034278ade5fd5c9c07b69f723254394aa4d053c5ab2889ba3fa48ce6491.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0533d40a1abbc0e717187ac0c4d29e07aa5a8ed7d6eb06c171df756201e6b94b.jpeg",
    "https://cdn.faire.com/fastly/1f1d65fec65f55337f742115dc5e4cc9d5d9a43f75663eb9d5b4269b6af70a6f.jpeg",
    "https://cdn.faire.com/fastly/0baba82d2dc1ebf754a5c3b281265e71dacafc7ebc624db080e0159c163a677f.jpeg",
    "https://cdn.faire.com/fastly/f2cd440a314ac320792b09d39ecead6bc0bf06424a23aaea57facec1c279703d.jpeg",
  ],
  priceDollars: 4.85,
  description:
    '18K Stainless Steel Tarnish-Free Chain Link Bracelet, crafted from premium 18K stainless steel, this bracelet features a bold chain on toggle closure. Its tarnish-free design ensures long-lasting shine and resilience, the bracelet is hypoallergenic, waterproof, fade-resistant, and tarnish-free. \n\nProduct Details:\nlength: 7"\next: 2"\nclasp: Clasp\nMetal finish: Stainless Steel 18K Gold\nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Bracelet\nStainless Steel Bracelet\nHypoallergenic Bracelet\nTarnish-Free Bracelet\nNon-Tarnish Bracelet\nWaterproof Bracelet\nWater Resistant Bracelet\nSweatproof Jewelry\nFade Resistant Bracelet\nAnti-oxidation \nPVD Coating',
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:33.952Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
